<template>
  <div
    class="w-full bg-dark-gray"
    :class="[stickyTop == true ? 'sticky top-0 z-50' : '']"
  >
    <nav
      class="mx-auto flex w-full justify-between gap-4 px-4 py-2"
      :class="[
        isUltra ? 'container-wide-ultra md:px-6' : 'container-max md:px-10',
      ]"
    >
      <div
        v-if="screenSize !== 'desktop'"
        class="z-10"
      >
        <div class="flex items-center">
          <icon-badge
            :visible="showIconBadge"
            @click="onToggleMenu"
          >
            <img
              class="inline h-8 w-8 cursor-pointer"
              :class="collapsed ? 'collapsed-menu' : 'open-menu'"
              src="@/assets/menu-icon.svg"
              alt=""
            />
          </icon-badge>

          <svg
            v-if="!searchSw"
            class="h-8 w-10"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="onSearch"
          >
            <path
              d="M19.52 19.8398L23.9999 24.3197"
              stroke="#C7CBDB"
              stroke-width="2"
            />
            <circle
              cx="15.68"
              cy="15.3602"
              r="6.67989"
              stroke="#C7CBDB"
              stroke-width="2"
            />
          </svg>
          <svg
            v-else
            class="h-8 w-10"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="onSearch"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16 13.8789L10.6965 8.57538L8.57519 10.6967L13.8787 16.0002L8.57557 21.3033L10.6969 23.4246L16 18.1215L21.3031 23.4246L23.4244 21.3033L18.1213 16.0002L23.4248 10.6967L21.3035 8.57538L16 13.8789Z"
              fill="#C7CBDB"
            />
          </svg>
        </div>
      </div>
      <div
        class="relative mx-auto flex w-full items-center justify-between"
        :class="{
          'py-2': screenSize === 'desktop' && !isCarrierProductEnabled,
          'container-max': !isUltra,
        }"
      >
        <div class="absolute left-0 z-0 w-full lg:relative lg:max-w-max">
          <div class="flex items-center justify-center gap-4 lg:justify-start">
            <router-link to="/carrier">
              <img
                class="logo logo-h"
                src="@/assets/highway_logo.svg"
                alt="highway logo"
                :class="`${screenSize == 'mobile' && 'mr-16'}`"
              />
            </router-link>
            <search-bar
              v-if="screenSize === 'desktop' && isCarrierProductEnabled"
            />
          </div>
        </div>
        <div class="z-10 flex items-center">
          <div
            v-if="screenSize === 'desktop'"
            class="flex items-center"
          >
            <div
              v-for="(item, index) in menu"
              :key="index"
              class="flex"
            >
              <link-badge
                v-if="!item.hidden"
                :item="item"
              />
            </div>
          </div>

          <div
            v-if="screenSize === 'desktop'"
            class="ml-2 flex items-center"
            @click="goToAccountOverview"
          >
            <p
              class="mr-2 hidden cursor-pointer text-xs text-yellow-500 sm:block"
            >
              {{ userName }}
            </p>
            <img
              class="-mt-1 inline h-6 w-6 text-yellow-500 hover:text-yellow-600"
              src="@/assets/yellow-account-icon.svg"
              alt="account icon"
            />
          </div>
          <svg
            v-if="helpHighwayURL && screenSize === 'desktop'"
            width="33"
            height="33"
            class="ml-2 inline cursor-pointer text-yellow-500 hover:text-yellow-600"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="margin-top: -4.5px; height: 25px; width: 25px"
            @click="openInNewTab(helpHighwayURL)"
          >
            <path
              d="M16.3357 3.91412C13.7645 3.91412 11.2511 4.67656 9.11329 6.10502C6.97545 7.53348 5.3092 9.5638 4.32527 11.9392C3.34133 14.3147 3.08388 16.9285 3.58549 19.4503C4.0871 21.9721 5.32523 24.2884 7.14331 26.1065C8.96139 27.9246 11.2778 29.1627 13.7995 29.6643C16.3213 30.1659 18.9351 29.9085 21.3106 28.9246C23.686 27.9406 25.7163 26.2744 27.1448 24.1365C28.5733 21.9987 29.3357 19.4853 29.3357 16.9141C29.3321 13.4674 27.9613 10.1629 25.5241 7.72576C23.0869 5.28857 19.7824 3.91776 16.3357 3.91412ZM16.3357 24.9141C16.039 24.9141 15.749 24.8261 15.5023 24.6613C15.2557 24.4965 15.0634 24.2622 14.9499 23.9881C14.8363 23.7141 14.8066 23.4125 14.8645 23.1215C14.9224 22.8305 15.0653 22.5632 15.275 22.3535C15.4848 22.1437 15.7521 22.0008 16.0431 21.9429C16.334 21.8851 16.6356 21.9148 16.9097 22.0283C17.1838 22.1418 17.4181 22.3341 17.5829 22.5808C17.7477 22.8274 17.8357 23.1175 17.8357 23.4141C17.8357 23.8119 17.6777 24.1935 17.3964 24.4748C17.1151 24.7561 16.7335 24.9141 16.3357 24.9141ZM17.3357 18.8241V18.9141C17.3357 19.1793 17.2303 19.4337 17.0428 19.6212C16.8553 19.8088 16.6009 19.9141 16.3357 19.9141C16.0705 19.9141 15.8161 19.8088 15.6286 19.6212C15.4411 19.4337 15.3357 19.1793 15.3357 18.9141V17.9141C15.3357 17.6489 15.4411 17.3946 15.6286 17.207C15.8161 17.0195 16.0705 16.9141 16.3357 16.9141C17.9894 16.9141 19.3357 15.7891 19.3357 14.4141C19.3357 13.0391 17.9894 11.9141 16.3357 11.9141C14.6819 11.9141 13.3357 13.0391 13.3357 14.4141V14.9141C13.3357 15.1793 13.2303 15.4337 13.0428 15.6212C12.8553 15.8088 12.6009 15.9141 12.3357 15.9141C12.0705 15.9141 11.8161 15.8088 11.6286 15.6212C11.4411 15.4337 11.3357 15.1793 11.3357 14.9141V14.4141C11.3357 11.9329 13.5782 9.91412 16.3357 9.91412C19.0932 9.91412 21.3357 11.9329 21.3357 14.4141C21.3357 16.5866 19.6157 18.4054 17.3357 18.8241Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <div
          v-if="screenSize !== 'desktop'"
          class="flex items-center"
        >
          <img
            class="h-8 w-8 cursor-pointer"
            src="@/assets/yellow-account-icon.svg"
            alt="account icon"
            @click="goToAccountOverview"
          />
          <svg
            v-if="helpHighwayURL"
            width="33"
            height="33"
            class="ml-2 inline cursor-pointer text-yellow-500 hover:text-yellow-600"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="margin-top: -0.5px; height: 34px; width: 34px"
            @click="openInNewTab(helpHighwayURL)"
          >
            <path
              d="M16.3357 3.91412C13.7645 3.91412 11.2511 4.67656 9.11329 6.10502C6.97545 7.53348 5.3092 9.5638 4.32527 11.9392C3.34133 14.3147 3.08388 16.9285 3.58549 19.4503C4.0871 21.9721 5.32523 24.2884 7.14331 26.1065C8.96139 27.9246 11.2778 29.1627 13.7995 29.6643C16.3213 30.1659 18.9351 29.9085 21.3106 28.9246C23.686 27.9406 25.7163 26.2744 27.1448 24.1365C28.5733 21.9987 29.3357 19.4853 29.3357 16.9141C29.3321 13.4674 27.9613 10.1629 25.5241 7.72576C23.0869 5.28857 19.7824 3.91776 16.3357 3.91412ZM16.3357 24.9141C16.039 24.9141 15.749 24.8261 15.5023 24.6613C15.2557 24.4965 15.0634 24.2622 14.9499 23.9881C14.8363 23.7141 14.8066 23.4125 14.8645 23.1215C14.9224 22.8305 15.0653 22.5632 15.275 22.3535C15.4848 22.1437 15.7521 22.0008 16.0431 21.9429C16.334 21.8851 16.6356 21.9148 16.9097 22.0283C17.1838 22.1418 17.4181 22.3341 17.5829 22.5808C17.7477 22.8274 17.8357 23.1175 17.8357 23.4141C17.8357 23.8119 17.6777 24.1935 17.3964 24.4748C17.1151 24.7561 16.7335 24.9141 16.3357 24.9141ZM17.3357 18.8241V18.9141C17.3357 19.1793 17.2303 19.4337 17.0428 19.6212C16.8553 19.8088 16.6009 19.9141 16.3357 19.9141C16.0705 19.9141 15.8161 19.8088 15.6286 19.6212C15.4411 19.4337 15.3357 19.1793 15.3357 18.9141V17.9141C15.3357 17.6489 15.4411 17.3946 15.6286 17.207C15.8161 17.0195 16.0705 16.9141 16.3357 16.9141C17.9894 16.9141 19.3357 15.7891 19.3357 14.4141C19.3357 13.0391 17.9894 11.9141 16.3357 11.9141C14.6819 11.9141 13.3357 13.0391 13.3357 14.4141V14.9141C13.3357 15.1793 13.2303 15.4337 13.0428 15.6212C12.8553 15.8088 12.6009 15.9141 12.3357 15.9141C12.0705 15.9141 11.8161 15.8088 11.6286 15.6212C11.4411 15.4337 11.3357 15.1793 11.3357 14.9141V14.4141C11.3357 11.9329 13.5782 9.91412 16.3357 9.91412C19.0932 9.91412 21.3357 11.9329 21.3357 14.4141C21.3357 16.5866 19.6157 18.4054 17.3357 18.8241Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </nav>
    <div
      v-if="screenSize !== 'desktop'"
      class="sidebar-menu-container absolute"
      :class="[!collapsed && 'w-full']"
      @click.self="closeToggleMenu"
    >
      <sidebar-menu
        :menu="menu"
        :collapsed="collapsed"
        width-collapsed="0"
        :hide-toggle="true"
        :disable-hover="true"
      />
    </div>
    <Transition name="expand-fade">
      <div
        v-if="searchSw && isCarrierProductEnabled && screenSize !== 'desktop'"
        class="flex w-full items-center gap-4 bg-dark-gray px-4"
        style="height: 54px"
      >
        <search-bar
          w-auto="w-full"
          class="w-full"
        />
      </div>
    </Transition>
  </div>
</template>
<script>
import { SidebarMenu } from 'vue-sidebar-menu';
import IconBadge from '@/components/IconBadge.vue';
import LinkBadge from '@/components/LinkBadge.vue';
import SearchBar from '@/components/SearchBar.vue';
import { mapGetters } from 'vuex';
import config from '@/config';

export default {
  name: 'HeaderMain',
  components: {
    IconBadge,
    LinkBadge,
    SidebarMenu,
    SearchBar,
  },
  props: {
    stickyTop: {
      type: Boolean,
      required: false,
      default: false,
    },
    narrow: {
      type: Boolean,
      required: false,
      default: false,
    },
    isUltra: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      collapsed: true,
      searchSw: false,
      screenSize:
        window.innerWidth >= 640
          ? window.innerWidth <= 1024
            ? 'tablet'
            : 'desktop'
          : 'mobile',
      badgeConf: {
        class: 'vsm--badge',
        badge: {
          text: '',
          class:
            'bg-badge-yellow flex-shrink bg-opacity-20 text-badge-link-yellow rounded-full text-1md flex justify-center items-center ml-4',
          element: 'span',
          attributes: {
            style: 'padding: 2px 8px;width: 30px; height: 24px;',
          },
        },
      },
    };
  },
  computed: {
    enableRateConfirmation() {
      return (
        this.$store.state.users.featureFlags?.enable_rate_confirmation_page
          ?.enabled &&
        this.$store.state.users.currentUser?.company?.company_type !==
          'dispatcher'
      );
    },
    helpHighwayURL() {
      if (!config.HELP_URL) return null;
      return `${config.HELP_URL}`;
    },
    isCarrierProductEnabled() {
      return (
        this.$store.getters['users/getFeatureFlag']?.('carrier_product')?.[
          'enabled'
        ] &&
        this.$store.state.users.currentUser?.company?.company_type !==
          'dispatcher'
      );
    },
    ...mapGetters({
      pendingConnectionsCount: 'dispatcherConnections/pendingConnectionsCount',
      pendingRequestsCount: 'userCompanyRequests/pendingRequestsCount',
    }),
    pendingCountBadgeConf() {
      const pendingBadgeCount = JSON.parse(JSON.stringify(this.badgeConf));
      if (
        this.pendingConnectionsCount &&
        pendingBadgeCount?.badge?.text !== undefined
      ) {
        pendingBadgeCount.badge.text = this.pendingConnectionsCount;
      }
      return pendingBadgeCount;
    },
    requestsCountBadgeConf() {
      // const requestsBadgeCount = {
      //   ...this.badgeConf,
      // };
      const requestsBadgeCount = JSON.parse(JSON.stringify(this.badgeConf));
      if (this.pendingRequestsCount)
        requestsBadgeCount.badge.text = this.pendingRequestsCount;
      return requestsBadgeCount;
    },
    showIconBadge() {
      if (
        this.$store.state.users.currentUser?.company?.company_type ===
        'dispatcher'
      )
        return false;
      return !!this.pendingConnectionsCount || !!this.pendingRequestsCount;
    },
    userName() {
      if (this.$store.state.users.currentUser) {
        return (
          this.$store.state.users.currentUser?.first_name +
          ' ' +
          this.$store.state.users.currentUser?.last_name
        );
      } else {
        return '';
      }
    },
    enableEquipmentRoute() {
      return this.$store.state.users.featureFlags?.equipment_route?.enabled;
    },
    canViewMyLoads() {
      return (
        this.$store.state.users.featureFlags?.enable_carrier_loads?.enabled &&
        this.$store.state.users.currentUser?.scopes?.includes(
          'carrier_load_abilities'
        )
      );
    },
    load_board_enabled() {
      return this.$store.state.users.currentUser?.scopes?.includes(
        'carrier_view_posted_loads'
      );
    },
    menu() {
      // Return if the user is null
      if (this.$store.state.users.currentUser == null) {
        return;
      }

      const scopes = this.$store.state.users.currentUser?.scopes || [];
      const managerUserExists = (element) => element === 'manage_users';
      const managerUserScope = scopes.some(managerUserExists);

      let menuItems = [];

      if (
        this.$store.state.users.currentUser.company.company_type ===
        'dispatcher'
      ) {
        menuItems = [
          {
            href: '/dispatcher',
            title: 'My Carriers',
          },
          {
            href: '/logout',
            title: 'Logout',
          },
        ];
      } else {
        menuItems = [
          ...(this.load_board_enabled
            ? [
                {
                  title: 'TRUSTED FREIGHT EXCHANGE',
                  disabled: true,
                  hidden: this.screenSize === 'desktop',
                  class: 'trusted-freight',
                },
                {
                  href: '/carrier/exchange/access/benefits',
                  title: 'Find Loads',
                  class: 'find-loads',
                },
                {
                  href: '/carrier/capacity',
                  title: 'Post Capacity',
                  class: 'post-capacity',
                },
              ]
            : []),
          ...(this.canViewMyLoads
            ? [
                {
                  href: '/carrier/loads',
                  title: 'My Loads',
                },
              ]
            : []),
          ...(this.enableEquipmentRoute
            ? [
                {
                  href: '/carrier/equipment',
                  title: 'Equipment',
                },
              ]
            : []),
          {
            href: '/carrier/brokers',
            title: 'My Brokers',
          },
          ...(this.enableRateConfirmation
            ? [
                {
                  href: '/carrier/rate-confirmations',
                  title: 'Rate Cons',
                },
              ]
            : []),
          {
            href: '/carrier/dispatcher_connections',
            title: 'Dispatchers',
            ...(this.pendingConnectionsCount ? this.pendingCountBadgeConf : {}),
          },
          ...(managerUserScope
            ? [
                {
                  href: '/carrier/users',
                  title: 'Users',
                  ...(this.pendingRequestsCount
                    ? this.requestsCountBadgeConf
                    : {}),
                },
              ]
            : []),
          {
            href: '/logout',
            title: 'Logout',
          },
        ];
      }

      return menuItems;
    },
  },
  async created() {
    await this.$store.dispatch('userCompanyRequests/getUserCompanyRequests');
    await this.$store.dispatch(
      'dispatcherConnections/getDispatcherConnections'
    );
  },

  mounted() {
    addEventListener('resize', () => {
      switch (true) {
        case window.innerWidth <= 640:
          return (this.screenSize = 'mobile');
        case window.innerWidth <= 1024:
          return (this.screenSize = 'tablet');
        default:
          return (this.screenSize = 'desktop');
      }
    });
  },
  methods: {
    openInNewTab(url) {
      window.open(url, '_blank');
    },
    onSearch() {
      this.searchSw = !this.searchSw;
    },
    onToggleMenu() {
      this.collapsed = !this.collapsed;
    },
    closeToggleMenu() {
      this.collapsed = true;
    },
    goToAccountOverview() {
      if (
        this.$store.state.users?.currentUser?.company?.company_type ===
        'dispatcher'
      ) {
        return this.$router.push('/dispatcher/account-overview');
      } else {
        return this.$router.push('/carrier/my-profile');
      }
    },
    // onItemClick(event, item) {
    //   const { title } = item;

    //   if (title === 'Log Out') {
    //     this.logOut()
    //     this.collapsed = !this.collapsed
    //   }
    // },
  },
};
</script>
<style scoped>
.collapsed-menu {
  transform: scale(-1);
}

.sidebar-menu-container {
  height: calc(100vh - 48px);
}

.logo-h {
  height: 15.91px !important;
}

.expand-fade-enter-active,
.expand-fade-leave-active {
  transition:
    max-height 0.4s ease-in-out,
    opacity 0.4s ease-in-out;
  overflow: hidden;
}

.expand-fade-enter-from,
.expand-fade-leave-to {
  max-height: 0;
  opacity: 0;
}

.expand-fade-enter-to,
.expand-fade-leave-from {
  max-height: 54px;
  opacity: 1;
}
</style>
